// ΔVΔVΔ: This code must be run at the start of the app or SCRIPT_URL will be null
const getLocalReactPath = () => {
    const scriptPath = document.currentScript.src;
    const divide = scriptPath.indexOf('/static/js/');
    return scriptPath.substring(0, divide);
};

const SCRIPT_URL = getLocalReactPath();
export { SCRIPT_URL };
